import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { curveOf } from "./curves";

// 🎨 Signature scientifique du nouveau design : papier millimétré de 28 px et courbe de la matière
// qui se trace lentement, une fois, à droite du contenu (maquette Recherche.html). Pas
// d'animation chez les visiteurs qui ont réglé « réduire les animations ». Décor seulement
// (aria-hidden) : le contenu passe en enfant, jamais sous une courbe en mouvement.
const REDUCED = "(prefers-reduced-motion: reduce)";
const prefersReducedMotion = () => {
  try {
    return !!window.matchMedia?.(REDUCED).matches;
  } catch {
    return false;
  }
};

export const useReducedMotion = () => {
  const [reduced, setReduced] = useState(prefersReducedMotion);
  useEffect(() => {
    const query = window.matchMedia?.(REDUCED);
    if (!query?.addEventListener) return undefined;
    const update = () => setReduced(query.matches);
    query.addEventListener("change", update);
    return () => query.removeEventListener("change", update);
  }, []);
  return reduced;
};

function Signature({ matiere = "maths", formula = true, className = "", children }) {
  const { i18n } = useTranslation();
  const reduced = useReducedMotion();
  const curve = curveOf(matiere, i18n?.language);
  return (
    <div className={`nd-signature${reduced ? "" : " nd-signature--anim"}${className ? ` ${className}` : ""}`} data-curve={curve.key}>
      <svg className="nd-signature__courbes" aria-hidden="true" focusable="false" viewBox="0 0 1440 300" preserveAspectRatio="none">
        <line x1="0" y1={curve.axeY} x2="1440" y2={curve.axeY} stroke="var(--nd-axe)" strokeWidth="1.5" vectorEffect="non-scaling-stroke" />
        {/* key : la courbe se retrace quand la matière change */}
        <path key={`a-${curve.key}`} className="nd-trace" d={curve.d1} fill="none" stroke="var(--nd-courbe)" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke" />
        {curve.d2 && <path key={`b-${curve.key}`} className="nd-trace" d={curve.d2} fill="none" stroke="var(--nd-courbe2)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke" />}
        {curve.barreaux && <path d={curve.barreaux} fill="none" stroke="var(--nd-courbe2)" strokeWidth="1.5" vectorEffect="non-scaling-stroke" opacity="0.7" />}
      </svg>
      {formula && (
        <span className="nd-signature__formule" aria-hidden="true">
          {curve.formula}
        </span>
      )}
      <div className="nd-signature__contenu">{children}</div>
    </div>
  );
}

export default Signature;
